define('app/dashboard/widgets/Top10ReportDashboardItemView',['require','./ReportDashboardItemView','glu/util','hbs!./Top10ReportDashboardItemView.hbs'],function(require) {

	'use strict';

	var ReportDashboardItemView = require('./ReportDashboardItemView'),
		_ = require('glu/util');

	return ReportDashboardItemView.extend({
		className: 'dashboard-item dashboard-item-top10-report',
		template: require('hbs!./Top10ReportDashboardItemView.hbs'),

		initialize: function() {
			// call base class initialize function
			ReportDashboardItemView.prototype.initialize.call(this);

			this.model.set('isLoading', true);
			this.listenTo(this.model, 'dataReceived', this.dataReceived);
			this.listenTo(this.model, 'change', this.render);
		},

		dataReceived: function() {
			this.model.set('isLoading', false);
			this.render();
		},

		isLoading: function() {
			return this.model.get('isLoading');
		},

		hasTop10ListResults: function() {
			return this.model.hasTop10ListResults();
		},

		rows: function() {
			var data = this.model.consumableResults().formattedData();

			return _.map(data.rows.slice(0, 10), function(row) {
				return {
					name: row[0],
					value: row[1],
					nameClass: 'dt-' + data.header[0].type.toLowerCase(),
					valueClass: 'dt-' + data.header[1].type.toLowerCase()
				};
			});
		}
	});
});

